module.exports = __webpack_public_path__ + "static/Group 466-2dacb5c7585fc21b179d15e65274681d.png";